import { BoxProps } from "@mantine/core";
import { t } from "i18next";

import { Icon } from "#shared/icons/Icon";
import { Chip } from "#shared/view/designSystem/Chip";

export const ArchivedChip = (props: BoxProps) => {
  return (
    <Chip
      size="xs"
      icon={<Icon name="check" size={14} />}
      checked
      color="grey.2"
      autoContrast
      {...props}
    >
      {t("qrl.archived")}
    </Chip>
  );
};
